import WebService, { ClientWebServiceOption, ServerWebServiceOption } from "services/WebService/WebService";
import { webserviceEndpoints } from 'data/constants';
import { CareerType } from 'types/types';

type SendJobApplicationRequestType = {
  name: string,
  email: string,
  phone_number: string,
  country: string,
  comment: string,
  experince: string,
};

type CareerListResponseType = {
  id: number,
  title: string,
  summary1: string,
  summary2: string,
  contact: string,
  form: boolean,
  display_order: number,
};

class CareerService {
  static async getCareers(): Promise<CareerType[]> {
    try {
      const option = new ServerWebServiceOption("GET", webserviceEndpoints.LE_CAREERS);
      const careers = await WebService.shared().callWebService(option) as CareerListResponseType[];
      const feCareersList = careers.map(({
        id,
        title,
        summary1,
        summary2,
        contact,
        display_order,
        form,
      }) => ({
        id: id,
        name: title,
        description: summary1,
        requirements: CareerService.getNormalizedRequirement(summary2),
        contact: contact,
        hasForm: form,
        displayOrder: display_order
      }),
      );
      return feCareersList.sort(({ displayOrder: a }, { displayOrder: b }) => a - b);
    } catch (error) {
      throw error;
    }
  }
  static getNormalizedRequirement(requirement: string): string {
    return requirement.replaceAll("\r\n", "<br />")
  }

  static sendJobApplication(jobApplication: SendJobApplicationRequestType): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        // TODO: Change the path when the API is ready
        const option = new ClientWebServiceOption("POST", webserviceEndpoints.FAKE, jobApplication);
        await WebService.shared().callWebService(option);
        resolve();
      } catch (error) {
        reject();
      }
    });
  }
};

export default CareerService;
